import { create } from 'zustand';

export const useCreditWarningStore = create((set) => ({
  isOpen: false,
  openModal: () => set({ isOpen: true }),
  closeModal: () => set({ isOpen: false }),
}));

export default useCreditWarningStore;
